import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import PropTypes from 'prop-types'

const SubmitFailure = ({ clubName, isOpen, toggle}) => (
  <Modal isOpen={isOpen} toggle={toggle} >
     <ModalHeader toggle={toggle}> Fout bij versturen </ModalHeader>
     <ModalBody>
       <p>
         Er is helaas iets misgegaan bij het versturen van het formulier. Probeer het later nog eens of neem contact op met {clubName}.
       </p>
     </ModalBody>
     <ModalFooter>
       <Button color="primary" onClick={toggle} > Sluiten </Button>{' '}
     </ModalFooter>
   </Modal>
 )

 SubmitFailure.propTypes = {
   clubName: PropTypes.string,
   toggle: PropTypes.func.isRequired,
   isOpen: PropTypes.bool.isRequired,
 }

export default SubmitFailure



// WEBPACK FOOTER //
// ./src/registrationform/SubmitFailure.jsx